import script from "./acme.cert-manager.io.order.vue?vue&type=script&lang=ts"
export * from "./acme.cert-manager.io.order.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__